var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2647,
    height: 1777,
    viewBox: "0 0 2647 1777",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H1318.84C1327.57 2 1335.29 7.6568 1337.91 15.9774L1365.09 102.023C1367.71 110.343 1375.43 116 1384.16 116H2625C2636.05 116 2645 124.954 2645 136V1755.5C2645 1766.55 2636.05 1775.5 2625 1775.5H22C10.9543 1775.5 2 1766.55 2 1755.5V22C2 10.9543 10.9543 2 22 2Z",
    fill: "white",
    stroke: "#FE531F",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBg2);
export default __webpack_public_path__ + "static/media/folderBg2.ef068cebaee0c6832be6c359de35793d.svg";
export { ForwardRef as ReactComponent };